<template>
  <div>
    <h3 class="title mb-3 green--text">
      Operadora Contratada / Administradora de Benefícios
    </h3>
    <p>
      <strong>Nome Fantasia: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.operadoraNomeFantasia : "" }}
    </p>
    <p>
      <strong>Razão Social: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.operadoraRazaoSocial : "" }}
    </p>
    <p>
      <strong>Nome Fantasia Adm. Benefícios : </strong
      >{{
        beneficiarioPinss ? beneficiarioPinss.administradoraNomeFantasia : ""
      }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Beneficiario",
  props: {
    beneficiarioPinss: Object
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
</style>
